import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Select, List, Icon } from 'antd'

import Servicefield from './Servicefield'

@inject((store: any) => {
    const { popupStore, servicefieldsStore } = store
    return { popupStore, servicefieldsStore }
})
@observer
export default class RightsPopup extends Component<any, any> {
    state: any = {
        errors: {}
    }
    closePopup = () => {
        this.props.servicefieldsStore.resetEdit()
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, servicefieldsStore } = this.props
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        return (
            <Modal
                title={'עריכת תחומי שירות'}
                visible={popupStore.popupType === 'editServicefields'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <Input.Search
                    value={servicefieldsStore.filters.name}
                    placeholder="הזן ערך לחיפוש תחום שירות"
                    onChange={e => servicefieldsStore.setFilter('name', e.target.value)}
                />
                <div style={{ paddingBottom: '2rem' }}>
                    <Servicefield servicefield={{ id: 'add', name: undefined }} />
                    <List
                        dataSource={servicefieldsStore.filteredList}
                        pagination={{ pageSize: 10 }}
                        renderItem={item => (
                            <List.Item style={{ padding: '0' }}>
                                <Servicefield servicefield={item} />
                            </List.Item>
                        )}
                    />
                </div>
            </Modal>
        )
    }
}
